import Validator from '@croco/validator'
import Sync from '@croco/sync'
import di from 'dependeny-injection';

class Register {
    /**
     * コンストラクタ
     *
     * @access public
     * @return void
     */
    constructor() {
        this.sync = new Sync();
        this.masked_mail = false;
        this.secondCode = false;
        this.csrfToken = document.querySelector("meta[name=csrf-token]").getAttribute("content");
        
        this.apiPath = '/register/api';

        this.coreData = new Validator({
            familyName: '',
            firstName: '',
            familyKana: '',
            firstKana: '',
            sex: '',
            birthYear: '',
            birthMonth: '',
            birthDay: '',
            pref: '',
            country: '',
            password: '',
            password2: '',
        });

        this.mailData = new Validator({
            mail: '',
        });

        this.codeData = new Validator({
            code: '',
        });

        this.agreeData = new Validator({
            edireco: '',
            privacy: ''
        });
        this.sexList = {
            '1': '男性',
            '2': '女性',
            '3': 'その他',
            '4': '無回答'
        };
    }

    dump(){
        return {
            masked_mail: this.masked_mail,
            secondCode: this.secondCode,
            coreData: this.coreData.toData(),
            mailData: this.mailData.toData(),
            codeData: this.codeData.toData(),
            agreeData: this.agreeData.toData()
        };
    }

    api(path, data) {
        data['csrf-token'] = this.csrfToken;
        return this.sync.post(this.apiPath + path, data);
    }

    beforeunload(e) {
        e.preventDefault();
        e.returnValue = '未保存のデータがありますが、本当に閉じますか？';
    }

    lockUnload(){
        window.addEventListener('beforeunload', this.beforeunload, false);
    }

    unlockUnload(){
        window.removeEventListener('beforeunload', this.beforeunload, false);
    }
    changeLoaderState(state, childObject = null, name) {
        di.loader.setState(state);
        if (childObject) {
            childObject[name] = state;
            childObject.update();
        }
    }

    validatePref(pref, country) {
        let props = {
            pref: pref ? '': '居住地を選択してください',
            country: ''
        };
        if (pref==48) {
            if (country == '') {
                props.country = '国名を入力してください'
            }
        }
        return props;
    }

    customValid(component, props) {
        let field;
        let messages = [];
        const errMsg = props[0];
        delete props[0];
        for (let name in props) {
          field = component.$(`[name="${name}"]`);
          if(props[name]){
            messages.push(props[name]);
            if (!field.closest('div.com-form__item__input').classList.contains('input-require')) {
              field.closest('div.com-form__item__input').classList.add('input-require');
            }
          } else {
            field.closest('div.com-form__item__input').classList.remove('input-require');
          }
        }
        field.closest('div.com-form__item__content').querySelectorAll('div.form__item__error').forEach((e) => {
          e.remove();
        });
        if (messages.length > 0 || errMsg) {
          let parentElement = field.closest('div.com-form__item__content');
          let error_div = document.createElement("div");
          error_div.classList.add("form__item__error");
          for (const message of messages) {
            let text = document.createTextNode( message );
            error_div.appendChild(text);
            error_div.appendChild(document.createElement( 'br' ));
          }
          if (errMsg) {
            for (let name in props) {
              field = component.$(`[name="${name}"]`);
              if (!field.closest('div.com-form__item__input').classList.contains('input-require')) {
                field.closest('div.com-form__item__input').classList.add('input-require');
              }
            }
            let text = document.createTextNode( errMsg );
            error_div.appendChild(text);
          }
          parentElement.appendChild(error_div);
          return false;
        }
        return true;
      };
} // class Register

// 確実に呼び出されるオブジェクト
di.set('register', new Register());

/* 
// ページ推移によって呼び出しが無い場合
di.registr('register', () => { 
    return new Register();
});
*/
